

import React, { useState, useEffect } from "react";
import axios from "../../axios";
import { get } from "lodash";
import { connect } from "react-redux";
import * as actionTypes from "../../store/actions";
import moment from "moment";
import { Field, Form, Formik } from "formik";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";
import Cookies from "js-cookie";
import { Icons, toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import JoditEditor from "jodit-react";
import { bottom } from "@popperjs/core";
import Input from "../../components/Input";
import { Modal } from "../../components/Modal";
import Overlay from "../../components/Overlay";
import { subAdminValidator } from "../../utils/validators";
import {
  extractDate,
  uploadImage,
  subadminAccessChange,
} from "../../utils/functions";

// Mui & material UI
import { makeStyles } from "@material-ui/core/styles";
import FormControlLabel from "@mui/material/FormControlLabel";

import Accordion from "@mui/material/Accordion";
import AccordionActions from "@mui/material/AccordionActions";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";

// React Icons
import { BsPlus } from "react-icons/bs";
import { RiEdit2Line } from "react-icons/ri";
import { MdExpandMore } from "react-icons/md";
import { RiDeleteBinLine } from "react-icons/ri";
import { RxCross2 } from "react-icons/rx";

// Elements
import {
  DashboardContainerData,
  DashboardWrapper,
  DashboardHeading,
  DashHeading,
  Button,
  Fields,
  CommonButton,
  ProfileDetailForm,
} from "./CMSElement";
import { colors } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  paperTableHeight: {
    width: "97%",
    marginLeft: "1rem",
    // minHeight: "87vh",
    border: "1px solid rgba(12, 45, 6, 0.10)",
    borderRadius: "10px",
  },
}));

const FaqJobHost = ({ setUsers, userData }) => {
  const adminData = JSON.parse(localStorage.getItem("userData") || userData || sessionStorage.getItem("userData"));

  

  const classes = useStyles();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [allFaqData, setAllFaqData] = useState();

  const [serviceType, setServiceType] = useState(
    localStorage.getItem("serviceTypefaq") || "serviceProvider"
  ); // Default to "serviceProvider"

  const handleServiceTypeChange = (type) => {
    setServiceType(type);
    localStorage.setItem("serviceTypefaq", type); // Save the active tab to localStorage
  };

  const [FAQsId, setFAQsId] = useState();
  const [deleteModal, setDeleteModal] = useState(false);

  // Fetch FAQ Data
  const fetchFAQUs = async () => {
    setIsLoading(true);
    try {
      const { data } = await axios.get(`/getAllFaq/serviceProvider`);

      setAllFaqData(data?.data);
    } catch (error) {
      handleErrorResponse(error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchFAQUs();
  }, [serviceType]); // Re-fetch when serviceType changes

  // Delete FAQs


  const handleErrorResponse = (error) => {
    const status = error?.response?.status;
    const message = error?.response?.data?.message || "";

    if (status === 422) {
      toast.error(message, { position: toast.POSITION.TOP_RIGHT });
    } else if (error?.response?.status === 901) {
      subadminAccessChange(navigate);
      toast.error(`${error.response.data?.message}`, {
        position: "top-right",
      });
    } else if (status === 419) {
      localStorage.clear();
      Cookies.remove("showProfileSidebar");
      setUsers("");
      toast.error(message, { position: toast.POSITION.TOP_RIGHT });
      navigate("/");
    } else {
      toast.error(message, { position: toast.POSITION.TOP_RIGHT });
    }
  };


  function stripHtml(html) {
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  }

  return (
    <>
      <DashboardContainerData>
        <DashboardWrapper>
          <ProfileDetailForm>
           

            <DashboardHeading>
              {(allFaqData || []).map((faq, index) => (
                <Accordion
                  key={faq._id}
                  sx={{
                    marginBottom: "10px",
                    border: "1px solid #375DFB54",
                    borderRadius: "6px",
                  }}
                >
                  <AccordionSummary
                    expandIcon={<MdExpandMore style={{ fontSize: "1.8rem" }} />}
                    aria-controls={`panel${index + 1}-content`}
                    id={`panel${index + 1}-header`}
                  >
                    <Typography component="span" style={{ color: "#181818", fontFamily: "Roboto", fontWeight: "500" }}>
                      {index + 1}. {faq.question}
                    </Typography>
                  </AccordionSummary>
                  <AccordionDetails style={{ display: "flex", justifyContent: "space-between", alignItems: "center", }}>
                    {/* <Typography style={{fontSize: "15px"}}>{faq.answer}</Typography> */}
                    <Typography
                      style={{ fontSize: "15px" }}
                      component="div"
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: faq.answer }}
                        style={{ whiteSpace: "pre-wrap" }}
                      />
                    </Typography>
                    <AccordionActions
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        gap: "1rem",
                      }}
                    >
                 
                    </AccordionActions>
                  </AccordionDetails>
                </Accordion>
              ))}
            </DashboardHeading>
          </ProfileDetailForm>
        </DashboardWrapper>
      </DashboardContainerData>
    

      {isLoading && <Overlay />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
    sidebar: state.sidebar,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
    setSidebar: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_SIDEBAR,
        updateSidebar: updatedValue,
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(FaqJobHost);

